import React from "react";

const MarkersLayer = (props) => {
    let markerKey = props.markerKey;
    let markerLayer = props.markerLayer;
    let reasonKey = props.reasonKey;
    let index = props.index;

    const Title = () => {
        let title = "";

        if (index === 1) {
            switch (markerLayer[markerKey][reasonKey].type) {
                case "sentry-occurrence":
                    title = <tr><td className="w-53.25 text-[12px]! pt-3.75"><strong>Ocorrências (Sentry)</strong></td></tr>;
                    break;
                case "dispatch-attendance":
                    title = <tr><td className="w-53.25 text-[12px]! pt-3.75"><strong>Atendimento</strong></td></tr>;
                    break;
                case "dispatch-bogcm":
                    title = <tr><td className="w-53.25 text-[12px]! pt-3.75"><strong>Despacho</strong></td></tr>;
                    break;
                case "dispatch-dispatches":
                    title = <tr><td className="w-53.25 text-[12px]! pt-3.75"><strong>{props.boName}</strong></td></tr>;
                    break;
            }
        }

        return <React.Fragment>{title}</React.Fragment>;
    }

    return (
        <React.Fragment>
            <Title />
            <tr key={Math.random().toString()}>
                <td className="w-53.25 text-[12px]!">{reasonKey}</td>
                <td className="w-53.25 text-[12px]!">{markerLayer[markerKey][reasonKey].amount}</td>
            </tr>
        </React.Fragment>
    );
}

export default MarkersLayer;